<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { enterInternalTest } from "../services/chat";

const router = useRouter();
const testId = ref("");
const nickname = ref("");
const accessCode = ref("");
const error = ref("");
const loading = ref(false);

async function enter(): Promise<void> {
  error.value = "";
  if (!testId.value.trim() || !nickname.value.trim() || !accessCode.value) {
    error.value = "请把测试编号、昵称和内部访问码都填好。";
    return;
  }
  loading.value = true;
  try {
    const result = await enterInternalTest(testId.value.trim(), nickname.value.trim(), accessCode.value);
    await router.replace(result.chatUrl);
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : "暂时无法进入测试。";
  } finally { loading.value = false; }
}
</script>

<template>
  <main class="entry-shell">
    <section class="entry-card">
      <div class="flower">🌻</div>
      <h1>小葵内部测试</h1>
      <p class="intro">小葵是面向青少年的 AI 陪伴教练，目前仅用于经授权的内部测试。</p>
      <form @submit.prevent="enter">
        <label>测试编号<input v-model="testId" autocomplete="username" maxlength="64" placeholder="例如：tester-001" /></label>
        <label>昵称<input v-model="nickname" maxlength="32" placeholder="例如：小明" /></label>
        <label>内部测试访问码<input v-model="accessCode" type="password" autocomplete="current-password" placeholder="由项目负责人提供" /></label>
        <p v-if="error" class="error">{{ error }}</p>
        <button :disabled="loading" type="submit">{{ loading ? "正在进入…" : "进入和小葵的对话" }}</button>
      </form>
      <details>
        <summary>使用与隐私提示</summary>
        <p>小葵是 AI，不是人类教练或医疗服务。本测试会保存聊天和已确认学习记录，用于改进产品；请不要输入家长联系方式、住址等不必要隐私。</p>
        <p>如出现想伤害自己或他人的紧急情况，请立刻告诉身边可信任的成年人并联系当地紧急救助。本版本尚未向真实学员开放。</p>
      </details>
    </section>
  </main>
</template>

<style scoped>
.entry-shell{min-height:100vh;display:grid;place-items:center;padding:24px;background:linear-gradient(160deg,#fff8e9,#f2eee5);color:#18334e}.entry-card{width:min(430px,100%);background:#fff;border-radius:24px;padding:34px;box-shadow:0 16px 45px #7a61301f}.flower{font-size:54px;text-align:center}h1{text-align:center;margin:8px 0 10px}.intro{line-height:1.7;color:#657080;margin-bottom:24px}form{display:grid;gap:14px}label{display:grid;gap:7px;font-weight:600}input{padding:13px;border:1px solid #ead7af;border-radius:12px;font-size:16px}button{margin-top:6px;padding:14px;border:0;border-radius:14px;background:#f7a633;color:white;font-size:16px;font-weight:700;cursor:pointer}button:disabled{opacity:.65}.error{margin:0;color:#bd3b3b;font-size:14px}details{margin-top:22px;color:#657080;font-size:13px;line-height:1.65}summary{cursor:pointer;font-weight:700;color:#35516a}
</style>
